<img
  [alt]="content.alt"
  [ngStyle]="styles"
  [src]="content.src"
  class="idp-image img-fluid"
/>
